<div *ngIf="isLoading" class="text-center my-3">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<div *ngIf="!isLoading" class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    Generate {{ title }}
    <span class="justify-content-end">
      <button class="btn" style="font-size: 25px" (click)="closeModal()">
        &times;
      </button>
    </span>
  </div>

  <div class="card-body">
    <div class="card-text">
      <form [formGroup]="formGroup">
        <div class="form-row py-2 my-2">
          <div class="row">
            <label>{{ "Form.AddPrompt" | translate }}</label>
          </div>
          <div class="row">
            <textarea rows="8" formControlName="prompt" readonly></textarea>
          </div>
        </div>

        <div class="form-row py-2 my-2">
          <div class="row">
            <label>{{ "Form.AdditionalBusiness" | translate }}</label>
          </div>
          <div class="row">
            <textarea
              id="additionaldetails"
              rows="3"
              formControlName="additionaldetails"
              placeholder="Add details to help improve the rewritten content"
            ></textarea>
          </div>
        </div>
      </form>
    </div>
    <div class="d-grid gap-2 d-md-block">
      <button
        type="button"
        class="btn btn-primary me-2"
        (click)="openConfirmation(content)"
      >
        {{ "Form.GenContent" | translate }}
      </button>
      <button
        type="button"
        class="btn btn-secondary me-2 pe-2"
        (click)="cancel()"
      >
        {{ "Form.CANCEL" | translate }}
      </button>
    </div>
  </div>
</div>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Proceed</h4>
    <button
      type="button"
      class="close mt-2"
      aria-label="Close"
      (click)="d('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body lang-popup">
    <p style="text-align: left">
      {{ "Form.ProceedWarning" | translate }}
    </p>
    <button
      id="proceedButton"
      type="button"
      class="btn btn-primary me-2"
      (click)="generateContent()"
    >
      {{ "Form.Proceed" | translate }}
    </button>
    <button id="cancelButton" type="button" class="btn btn-secondary me-2 pe-2">
      {{ "Form.CANCEL" | translate }}
    </button>
  </div>
</ng-template>
